module.exports = __webpack_public_path__ + "media/images/bookings/childcare/pro_recommendation_sticker@2x-6b9d25e8fd939d4c1840ade0b2701b41.png";